import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DataService } from '../data/data.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private dataService: DataService) {}

  // domain = 'http://localhost:3000';
  // domain = 'https://api.rawnest.in';
  domain = environment.backendDomain;

  apis = {
    checkVersion: `${this.domain}/serveasy/version`,

    getProducts: `${this.domain}/serveasy/products`,
    createProduct: `${this.domain}/serveasy/products`,
    deleteProduct: `${this.domain}/serveasy/products`,
    updateProduct: `${this.domain}/serveasy/products`,
    getProductById: `${this.domain}/serveasy/products/product/`,
    getProductTypes: `${this.domain}/serveasy/products/types`,
    getIngredientList: `${this.domain}/serveasy/products/ingredient-list`,
    getProductsForVendor: `${this.domain}/serveasy/products/contact`,
    getProductsForSaleOrder: `${this.domain}/serveasy/products/sales-contact`,
    deleteProductsForVendor: `${this.domain}/serveasy/products/contact`,
    addProductsForVendor: `${this.domain}/serveasy/products/contact`,
    productSellers: `${this.domain}/serveasy/products/sellers`,
    getProductBuyers: `${this.domain}/serveasy/products/buyers`, //buyers
    checkUniqueSKU: `${this.domain}/serveasy/products/unique-sku`,
    getProductRecipe: `${this.domain}/serveasy/products/recipe`, //recipe
    getProductPo: `${this.domain}/serveasy/products/purchase-order`, //purchase order
    getProductSo: `${this.domain}/serveasy/products/sales-order`, //sale order
    editProduct: `${this.domain}/serveasy/products/contact`, //edit product
    setSellerForProduct: `${this.domain}/serveasy/products/sellers`, //edit product
    getStockForProduct: `${this.domain}/serveasy/products/stocks`,
    getProductIntegrations: `${this.domain}/serveasy/products/integrations`,
    createProductIntegrations: `${this.domain}/serveasy/products/integrations`,
    getProductTimeline: `${this.domain}/serveasy/products/timeline`,
    getBrands: `${this.domain}/serveasy/products/brands`,

    //smartcart apis
    getListOfItemsForSmartCart: `${this.domain}/serveasy/smartcart/item-list`,
    getListOfItemsForCart: `${this.domain}/serveasy/smartcart/products`,
    getCartItems: `${this.domain}/serveasy/smartcart/items`,
    addItemToCart: `${this.domain}/serveasy/smartcart/add`,
    deleteCartItem: `${this.domain}/serveasy/smartcart/item`,
    deleteCart: `${this.domain}/serveasy/smartcart/cart`,
    placeOrder: `${this.domain}/serveasy/smartcart/place-order`,

    //template apis
    getTemplateList: `${this.domain}/serveasy/templates`,
    createTemplate: `${this.domain}/serveasy/templates`,
    getTemplateItems: `${this.domain}/serveasy/templates`,
    getAllProducts: `${this.domain}/serveasy/templates/products`,
    deleteTemplate: `${this.domain}/serveasy/templates`,
    updateTemplate: `${this.domain}/serveasy/templates`,
    editTemplate: `${this.domain}/serveasy/templates`,

    //bills api
    getAllBillList: `${this.domain}/serveasy/bills/all`,
    getBillList: `${this.domain}/serveasy/bills/list`,
    updateBillStatus: `${this.domain}/serveasy/bills/status`,
    billApproval: `${this.domain}/serveasy/bills/update`,
    uploadBillToS3: `${this.domain}/serveasy/bills/upload`,
    getBillDocument: `${this.domain}/serveasy/bills/pdf`,
    createManualPayment: `${this.domain}/serveasy/razorpay/manual-payment`,

    getBillsForPO: `${this.domain}/serveasy/bills/order`,
    deleteBillDocument: `${this.domain}/serveasy/bills/remove`,
    updateBill: `${this.domain}/serveasy/bills/update`,
    deleteBill: `${this.domain}/serveasy/bills`,
    createBill: `${this.domain}/serveasy/bills/add`,
    getBillHistory: `${this.domain}/serveasy/bills/history`,

    getVendorsForBills: `${this.domain}/serveasy/bills/vendors`,
    getPOForBills: `${this.domain}/serveasy/bills/purchase_orders`,
    createMultipleBills: `${this.domain}/serveasy/bills/create`,

    //login api
    login: `${this.domain}/serveasy/users/login`,

    getUsers: `${this.domain}/serveasy/users`,
    getUserDetails: `${this.domain}/serveasy/users`,
    createUser: `${this.domain}/serveasy/users`,
    createContact: `${this.domain}/serveasy/users/contact`,
    updateContact: `${this.domain}/serveasy/users/contact`,
    getAllContacts: `${this.domain}/serveasy/users/all`,
    getCustomers: `${this.domain}/serveasy/invoices/contacts`,
    generatePasswordForContact: `${this.domain}/serveasy/users/generate-password`,
    deleteContact: `${this.domain}/serveasy/users`,
    getOrdersForContact: `${this.domain}/serveasy/orders/vendor-order-list`,
    getAddress: `${this.domain}/serveasy/users/address`,
    saveAddress: `${this.domain}/serveasy/users/address`,
    deleteAddress: `${this.domain}/serveasy/users/address`,
    makePrimaryAddress: `${this.domain}/serveasy/users/primary`,
    getUserInformation: `${this.domain}/serveasy/users/information`,
    getIntegrations: `${this.domain}/serveasy/users/integrations`,
    getContactDetailsForProducts: `${this.domain}/serveasy/products/contact/`,

    //unit api
    getUnits: `${this.domain}/serveasy/units`,

    getDepartments: `${this.domain}/serveasy/department`,

    //sellers buyers api
    getSellers: `${this.domain}/serveasy/orders/sellers`,
    getSellersAddress: `${this.domain}/serveasy/orders/sellerAddress`,
    getBuyers: `${this.domain}/serveasy/orders/buyers`,
    getBuyersAddress: `${this.domain}/serveasy/orders/buyersAddress`,

    //purchase order api
    createPurchaseOrder: `${this.domain}/serveasy/orders/purchase_order`,
    getPurchaseOrderDataList: `${this.domain}/serveasy/orders/list`,
    getPurchaseOrderDetails: `${this.domain}/serveasy/orders/purchase_order`,
    approvePurchaseOrder: `${this.domain}/serveasy/orders/purchase_order/approve`,
    getReceivingData: `${this.domain}/serveasy/orders/purchase_order/items`,
    updateReceivingData: `${this.domain}/serveasy/orders/purchase_order/receive`,
    getPurchaseOrderEditData: `${this.domain}/serveasy/orders/purchase_order_edit`,
    savePurchaseOrderEditData: `${this.domain}/serveasy/orders/purchase_order/edit`,
    getCurrentStockStatus: `${this.domain}/serveasy/products/stock`,
    createGRN: `${this.domain}/serveasy/orders/grn`,
    getGRN: `${this.domain}/serveasy/orders/grn`,

    //sales order api
    createSalesOrder: `${this.domain}/serveasy/orders/sales_order`,
    getSalesOrderDetails: `${this.domain}/serveasy/orders/sales_order`,
    getSalesOrderEditData: `${this.domain}/serveasy/orders/sales_order_edit`,
    saveSalesOrderEditData: `${this.domain}/serveasy/orders/sales_order/edit`,
    approveSalesOrder: `${this.domain}/serveasy/orders/sales_order/approve`,

    getInventoryProducts: `${this.domain}/serveasy/inventory/products`,
    createClosingInventory: `${this.domain}/serveasy/inventory/closing`,
    createWastageLog: `${this.domain}/serveasy/inventory/ingredient-wastage`,
    getStockControl: `${this.domain}/serveasy/inventory/stock-control`,
    saveStockControl: `${this.domain}/serveasy/inventory/stock-control`,
    getCurrentStock: `${this.domain}/serveasy/inventory/current-stock`,
    createStaffConsumptionLog: `${this.domain}/serveasy/inventory/staff`,
    getInventoryLog: `${this.domain}/serveasy/products/product-list`,
    getInventoryList: `${this.domain}/serveasy/products/product-list`,

    getOutlets: `${this.domain}/serveasy/permissions/outlets`,
    getFeaturesList: `${this.domain}/serveasy/permissions/features`,
    getUserPermissions: `${this.domain}/serveasy/permissions/user`,
    saveUserPermissions: `${this.domain}/serveasy/permissions/user`,

    getPricing: `${this.domain}/serveasy/products/pricing`,

    getCurrentStockReport: `${this.domain}/serveasy/reports/current_stock_report`,
    productPricingVarianceReport: `${this.domain}/serveasy/reports/product_pricing_variance`,
    productConsumptionReport: `${this.domain}/serveasy/reports/product_consumption`,
    POWiseItemReport: `${this.domain}/serveasy/reports/po_wise_item`,
    dateWiseWastageReport: `${this.domain}/serveasy/reports/date_wise_wastage`,
    dateWiseStaffConsumptionReport: `${this.domain}/serveasy/reports/date_wise_staff_consumption`,
    itemWiseWastageReport: `${this.domain}/serveasy/reports/item_wise_wastage`,
    itemWiseStaffConsumptionReport: `${this.domain}/serveasy/reports/item_wise_staff_consumption`,
    getMonthlyVarianceReport: `${this.domain}/serveasy/reports/monthly_variance`,
    getWeeklyVarianceReport: `${this.domain}/serveasy/reports/weekly_variance`,

    //planning apis
    createPlanningList: `${this.domain}/serveasy/planning/add`,
    getPlanningList: `${this.domain}/serveasy/planning/list`,
    viewPlanningData: `${this.domain}/serveasy/planning/view`,
    getRecipesForPlanning: `${this.domain}/serveasy/planning/recipes`,
    getDataForUpdatingPopup: `${this.domain}/serveasy/planning/update`,
    updateFinalQuantity: `${this.domain}/serveasy/planning/update`,
    getPlanningForInventoryLog: `${this.domain}/serveasy/planning/inventory-log`,

    //categories apis
    getCategories: `${this.domain}/serveasy/categories/`,
    createCategories: `${this.domain}/serveasy/categories/`,
    updateCategories: `${this.domain}/serveasy/categories/`,
    checkProductsOfCategories: `${this.domain}/serveasy/categories/check`,
    changeCategoryOfProduct: `${this.domain}/serveasy/categories/change`,
    deleteCategory: `${this.domain}/serveasy/categories/`,

    // pos orders
    getPosOrders: `${this.domain}/serveasy/pos`,
    linkExternalIdWithProduct: `${this.domain}/serveasy/pos/link`,
    getPOSOrderRecipes: `${this.domain}/serveasy/pos/recipes`,
    getPosOrderInformation: `${this.domain}/serveasy/pos/information`,

    // zoho
    // getZohoAccessToken: `${this.domain}/serveasy/zoho/access_token`,
    createToken: `${this.domain}/serveasy/zoho/authorize`,
    getZohoContacts: `${this.domain}/serveasy/zoho/contacts`,
    getZohoAccounts: `${this.domain}/serveasy/zoho/accounts`,
    uploadBillToZoho: `${this.domain}/serveasy/zoho/upload_bill`,

    // razorpay
    createRazorpayPayout: `${this.domain}/serveasy/razorpay/payout`,
    getRazorpayContacts: `${this.domain}/serveasy/razorpay/contacts`,
    getRazorpayFunds: `${this.domain}/serveasy/razorpay/funds`,
    getRazorpayHistory: `${this.domain}/serveasy/razorpay/history`,

    // bill permissions settings
    getBillSettings: `${this.domain}/serveasy/settings/bills/permissions`,
    createBillSettings: `${this.domain}/serveasy/settings/bills/permissions`,
    checkBillPermissions: `${this.domain}/serveasy/settings/bills/permissions/check`,

    // bill group settings
    getContactsForBillSettings: `${this.domain}/serveasy/settings/contacts`,
    getBillGroups: `${this.domain}/serveasy/settings/bill/groups`,
    createBillGroups: `${this.domain}/serveasy/settings/bill/groups`,
    updateBillGroup: `${this.domain}/serveasy/settings/bill/groups`,

    // notifications
    getNotifications: `${this.domain}/serveasy/notifications`,
    changeReadStatus: `${this.domain}/serveasy/notifications/read-status`,
    markAsDelete: `${this.domain}/serveasy/notifications`,

    // dashboard
    getDashboardWidgets: `${this.domain}/serveasy/dashboard/widgets`,
    createWidgetsLayout: `${this.domain}/serveasy/dashboard/layout`,
    getWidgetsForGroup: `${this.domain}/serveasy/dashboard/layout`,
    getListOfWidgetsForUser: `${this.domain}/serveasy/dashboard/user/widgets`,
    getSalesOrdersForDashboard: `${this.domain}/serveasy/dashboard/sales`,
    getPurchaseOrdersForDashboard: `${this.domain}/serveasy/dashboard/purchases`,
    getPurchaseSalesForDashboard: `${this.domain}/serveasy/dashboard/purchase-sales`,
    getOrderCount: `${this.domain}/serveasy/dashboard/sales/count`,
    getTotalSalesValue: `${this.domain}/serveasy/dashboard/sales/value`,
    getTotalSalesCount: `${this.domain}/serveasy/dashboard/sales/count-value`,
    getTotalDiscount: `${this.domain}/serveasy/dashboard/discounts`,
    getTotalProductsSold: `${this.domain}/serveasy/dashboard/products-sold`,
    getAverageOrderValue: `${this.domain}/serveasy/dashboard/average-order-value`,
    getAverageProductPerOrder: `${this.domain}/serveasy/dashboard/average-product-per-order`,
    getSalesByPlatform: `${this.domain}/serveasy/dashboard/sales-by-platform`,
    getTopSellingItemByRevenue: `${this.domain}/serveasy/dashboard/top-selling-products`,
    getTotalPurchaseCount: `${this.domain}/serveasy/dashboard/purchase/count`,
    getTotalPurchaseValue: `${this.domain}/serveasy/dashboard/purchase/value`,
    getToatlPurchaseValues: `${this.domain}/serveasy/dashboard/purchase/count-values`,
    getRecentPurchaseHistory: `${this.domain}/serveasy/dashboard/recent-purchase-sales`,
    getTopWastageItems: `${this.domain}/serveasy/dashboard/wasted/products`,
    getTotalWastageValue: `${this.domain}/serveasy/dashboard/wastage/value`,
    getProductsBySale: `${this.domain}/serveasy/dashboard/products-by-sale`,
    getTotalVarianceValue: `${this.domain}/serveasy/dashboard/variance/value`,
    getTotalInventoryValue: `${this.domain}/serveasy/dashboard/inventory/value`,
    getTopVarianceItems: `${this.domain}/serveasy/dashboard/variance/products`,
    getIncomeExpense: `${this.domain}/serveasy/dashboard/income-expense`,

    // shopify
    fetchShopifyProducts: `${this.domain}/serveasy/shopify/products`,
    saveShopifyProducts: `${this.domain}/serveasy/shopify/products`,

    // woocommerce
    fetchWoocommerceProducts: `${this.domain}/serveasy/woocommerce/products`,
    saveWoocommerceProducts: `${this.domain}/serveasy/woocommerce/products`,

    // Sequence data
    getSequenceData: `${this.domain}/serveasy/sequence`,
    addSequenceData: `${this.domain}/serveasy/sequence`,

    // integrations-tab
    getIntegrationsForProducts: `${this.domain}/serveasy/integration/all`,
    addIntegrations: `${this.domain}/serveasy/integration`,
    deleteIntegration: `${this.domain}/serveasy/integration`,
    updateIntegration: `${this.domain}/serveasy/integration`,

    getSchedules: `${this.domain}/serveasy/schedule`,
    createSchedule: `${this.domain}/serveasy/schedule`,

    // auth
    requestOtp: `${this.domain}/serveasy/auth/otp/request`,
    verifyOtp: `${this.domain}/serveasy/auth/otp/verify`,
    twoFactorAuth: `${this.domain}/serveasy/auth/2fa/verify`,

    generate2FA: `${this.domain}/serveasy/auth/2fa/generate`,
    delete2FA: `${this.domain}/serveasy/auth/2fa`,
    save2FA: `${this.domain}/serveasy/auth/2fa`,
    get2FAInformation: `${this.domain}/serveasy/auth/2fa/information`,

    // invoices
    getInvoices: `${this.domain}/serveasy/invoices`,
    addInvoices: `${this.domain}/serveasy/invoices`,
    viewInvoices: `${this.domain}/serveasy/invoices/sales-order`,

    // languages
    getLanguage: `${this.domain}/serveasy/users/language`,
    changeLanguage: `${this.domain}/serveasy/users/language`,

    //products-nav
    getAllProductsForProductsNav: `${this.domain}/serveasy/products/all`,

    // bulk sales

    getAllProductsForBulkSales: `${this.domain}/serveasy/cheggs/products`,

    syncInventory: `${this.domain}/serveasy/cheggs/order`,
  };

  checkVersion() {
    return this.http.get(this.apis.checkVersion);
  }

  // ------------------ Products ------------------
  getProducts(type: any, search: any = '', page: any = 1, limit: any = 10) {
    const business_id = this.dataService.userDetails.business_id;

    return this.http.get(this.apis.getProducts, {
      params: {
        type,
        business_id,
        outlet_id: this.dataService.selectedOutlet,
        search,
        page,
        limit,
      },
    });
  }
  getProductById(id: string | number) {
    return this.http.get(this.apis.getProductById + id);
  }

  getIngredientList() {
    const outletId = this.dataService.selectedOutlet;
    return this.http.get(this.apis.getIngredientList, {
      params: {
        outletId,
        businessId: this.dataService.userDetails.business_id,
      },
    });
  }

  getProductTypes() {
    return this.http.get(this.apis.getProductTypes);
  }

  createProduct(data: any, recipeData: any) {
    return this.http.post(this.apis.createProduct, { data, recipeData });
  }

  updateProduct(id: string | number, data: any, recipeData: any) {
    return this.http.put(this.apis.updateProduct, { data, recipeData, id });
  }

  getPricing() {
    const outletId = this.dataService.selectedOutlet;
    const businessId = this.dataService.userDetails.business_id;

    return this.http.get(this.apis.getPricing, {
      params: { businessId, outletId },
    });
  }

  getProductTimeline(product_id: string | number) {
    const outlet_id = this.dataService.selectedOutlet;

    return this.http.get(this.apis.getProductTimeline, {
      params: { product_id, outlet_id },
    });
  }

  getBrands() {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getBrands, { params: { business_id } });
  }

  // ------------------ Reports ------------------

  getCurrentStockReport() {
    return this.http.get(this.apis.getCurrentStockReport, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }

  productPricingVarianceReport(
    start_date: string,
    end_date: string,
    outlets: any
  ) {
    return this.http.get(this.apis.productPricingVarianceReport, {
      params: {
        outlets,
        start_date,
        end_date,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  productConsumptionReport(start_date: string, end_date: string, outlets: any) {
    return this.http.get(this.apis.productConsumptionReport, {
      params: {
        outlets,
        start_date,
        end_date,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  POWiseItemReport(start_date: string, end_date: string, outlets: any) {
    return this.http.get(this.apis.POWiseItemReport, {
      params: {
        outlets,
        start_date,
        end_date,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  dateWiseWastageReport(start_date: string, end_date: string, outlets: any) {
    return this.http.get(this.apis.dateWiseWastageReport, {
      params: {
        outlets,
        start_date,
        end_date,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  dateWiseStaffConsumptionReport(
    start_date: string,
    end_date: string,
    outlets: any
  ) {
    return this.http.get(this.apis.dateWiseStaffConsumptionReport, {
      params: {
        outlets,
        start_date,
        end_date,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  itemWiseWastageReport(start_date: string, end_date: string, outlets: any) {
    return this.http.get(this.apis.itemWiseWastageReport, {
      params: {
        outlets,
        start_date,
        end_date,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  itemWiseStaffConsumptionReport(
    start_date: string,
    end_date: string,
    outlets: any
  ) {
    return this.http.get(this.apis.itemWiseStaffConsumptionReport, {
      params: {
        outlets,
        start_date,
        end_date,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  getMonthlyVarianceReport() {
    let outlets = this.dataService.getSelectedOutletIds();
    return this.http.get(this.apis.getMonthlyVarianceReport, {
      params: {
        outlets,
      },
    });
  }

  getWeeklyVarianceReport() {
    let outlets = this.dataService.getSelectedOutletIds();
    return this.http.get(this.apis.getWeeklyVarianceReport, {
      params: {
        outlets,
      },
    });
  }

  // ------------------ Contact's products ------------------

  getProductsForVendor(contactId: string | number) {
    let outletId = this.dataService.selectedOutlet
      ? this.dataService.selectedOutlet
      : this.dataService.outlets[0].id;
    if (contactId == 0) {
      return this.http.get(this.apis.getProductsForVendor, {
        params: {
          outletId,
          businessId: this.dataService.userDetails.business_id,
        },
      });
    }
    return this.http.get(this.apis.getProductsForVendor, {
      params: {
        contactId,
        outletId,
      },
    });
  }

  getProductsForSaleOrder() {
    return this.http.get(this.apis.getProductsForSaleOrder, {
      params: {
        businessId: this.dataService.userDetails.business_id,
        outletId: this.dataService.selectedOutlet,
      },
    });
  }

  getSellersForProducts(productId: string | number) {
    return this.http.get(this.apis.productSellers, {
      params: { productId },
    });
  }

  getBuyersForProducts(productId: string | number) {
    //buyer
    return this.http.get(this.apis.getProductBuyers, {
      params: { productId },
    });
  }

  getRecipeForProducts(productId: string | number) {
    //recipe
    return this.http.get(this.apis.getProductRecipe, {
      params: { productId },
    });
  }

  getPoForProducts(productId: string | number) {
    //po
    let businessId = this.dataService.userDetails.business_id;
    let outletId = this.dataService.selectedOutlet;
    return this.http.get(this.apis.getProductPo, {
      params: {
        productId,
        businessId,
        outletId,
      },
    });
  }

  getSoForProducts(productId: string | number) {
    //so
    let businessId = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getProductSo, {
      params: {
        productId,
        businessId,
      },
    });
  }

  checkUniqueSKU(sku: any) {
    let businessId = this.dataService.userDetails.business_id;
    return this.http.post(this.apis.checkUniqueSKU, {
      sku,
      businessId,
    });
  }

  makePrimarySeller(productId: string | number, sellerId: string | number) {
    return this.http.put(this.apis.productSellers, { productId, sellerId });
  }

  addProductsForVendor(data: any) {
    const outletId = this.dataService.selectedOutlet
      ? this.dataService.selectedOutlet
      : this.dataService.outlets[0].id;
    data.outlet_id = outletId;
    return this.http.post(this.apis.addProductsForVendor, data);
  }

  deleteProductsForVendor(id: string | number) {
    return this.http.delete(this.apis.deleteProductsForVendor, {
      params: { id },
    });
  }

  deleteProduct(id: string | number) {
    return this.http.delete(this.apis.deleteProduct, {
      params: { id },
    });
  }

  getOrdersForContact(order_type: any, vendor_id: number | string) {
    let business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getOrdersForContact, {
      params: {
        business_id,
        order_type,
        vendor_id,
      },
    });
  }

  editProduct(
    id: string | number,
    moq: string | number,
    price: string | number,
    discount: string | number,
    tax: string | number
  ) {
    return this.http.put(this.apis.editProduct, {
      id,
      moq,
      price,
      discount,
      tax,
    });
  }

  setSellerForProduct(
    productId: string | number,
    moq: string | number,
    price: string | number,
    sellerId: string | number
  ) {
    let outletId = this.dataService.selectedOutlet
      ? this.dataService.selectedOutlet
      : this.dataService.outlets[0].id;
    return this.http.post(this.apis.setSellerForProduct, {
      productId,
      sellerId,
      moq,
      outletId,
      price,
    });
  }

  getStockForProduct(productId: string | number, level: number, type: number) {
    return this.http.get(this.apis.getStockForProduct, {
      params: {
        productId,
        outletId: this.dataService.selectedOutlet
          ? this.dataService.selectedOutlet
          : this.dataService.outlets[0].id,
        level,
        type,
      },
    });
  }

  getProductIntegrations(product_id: string | number) {
    return this.http.get(this.apis.getProductIntegrations, {
      params: { product_id },
    });
  }

  createProductIntegrations(product_id: string | number, data: any) {
    let business_id = this.dataService.userDetails.business_id;
    return this.http.post(this.apis.createProductIntegrations, {
      data,
      product_id,
      business_id,
    });
  }

  // ----------------------------------------------
  // ------------------ Users ---------------------
  login(data: { email: string; password: string }) {
    return this.http.post(this.apis.login, data);
  }

  getUserDetails() {
    return this.http.get(this.apis.getUserDetails);
  }
  createUser(data: any) {
    return this.http.post(this.apis.createUser, data);
  }
  createContact(data: any) {
    return this.http.post(this.apis.createContact, data);
  }

  updateContact(data: any, id: string | number) {
    return this.http.put(this.apis.updateContact, { data, id });
  }

  getAllContacts(
    type: string | number,
    search: any = '',
    page: any = 1,
    limit: any = 10
  ) {
    const business_id = this.dataService.userDetails.business_id;
    // const business_id = 2;
    return this.http.get(this.apis.getAllContacts, {
      params: { type, business_id, search, page, limit },
    });
  }

  getCustomers() {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getCustomers, {
      params: { business_id },
    });
  }

  deleteContact(id: number | string) {
    return this.http.delete(this.apis.deleteContact, {
      params: { id },
    });
  }
  generatePassword(password: any) {
    return this.http.post(this.apis.generatePasswordForContact, {
      password,
    });
  }
  // --------------Users Address----------------

  getAddress(id: string | number) {
    return this.http.get(this.apis.getAddress, { params: { id } });
  }

  saveAddress(data: any) {
    return this.http.post(this.apis.saveAddress, data);
  }

  deleteAddress(id: string | number) {
    return this.http.delete(this.apis.deleteAddress, { params: { id } });
  }

  makePrimaryAddress(id: string | number, contact_id: string | number) {
    return this.http.put(this.apis.makePrimaryAddress, { id, contact_id });
  }

  getUserInformation(id: string | number) {
    return this.http.get(this.apis.getUserInformation + '/' + id);
  }

  getIntegrations(id: string | number) {
    return this.http.get(this.apis.getIntegrations, {
      params: { id },
    });
  }

  getContactDetailsForProducts(contactId: string | number) {
    return this.http.get(this.apis.getContactDetailsForProducts + contactId);
  }

  // ----------------------------------------------
  // ------------------ Units ---------------------
  getUnits() {
    return this.http.get(this.apis.getUnits);
  }

  // ----------------------------------------------
  // ------------------ Departments ---------------------
  getDepartments() {
    return this.http.get(this.apis.getDepartments);
  }

  // ----------------------------------------------
  // ------------------ Orders ---------------------

  getSellers() {
    return this.http.get(this.apis.getSellers, {
      params: {
        outletId: this.dataService.selectedOutlet
          ? this.dataService.selectedOutlet
          : this.dataService.outlets[0].id,
      },
    });
  }

  getSellersAddress(sellerId: string | number) {
    if (sellerId == 0) {
      return this.http.get(this.apis.getSellersAddress, {
        params: { businessId: this.dataService.userDetails?.business_id },
      });
    }
    return this.http.get(this.apis.getSellersAddress, { params: { sellerId } });
  }
  getBuyers() {
    return this.http.get(this.apis.getBuyers, {
      params: {
        outletId: this.dataService.selectedOutlet
          ? this.dataService.selectedOutlet
          : this.dataService.outlets[0].id,
      },
    });
  }

  getBuyersAddress() {
    return this.http.get(this.apis.getBuyersAddress, {
      params: { businessId: this.dataService.userDetails.business_id },
    });
  }

  getCurrentStockStatus(outletId: any, contactId: any) {
    if (contactId == 0) {
      return this.http.get(this.apis.getCurrentStockStatus, {
        params: {
          outletId: outletId ? outletId : this.dataService.selectedOutlet,
          business_id: this.dataService.userDetails.business_id,
          contactId: 0,
        },
      });
    }
    return this.http.get(this.apis.getCurrentStockStatus, {
      params: {
        outletId,
        contactId,
      },
    });
  }

  createGRN(po_id: number, outlet_id: number) {
    return this.http.post(this.apis.createGRN, {
      po_id,
      outlet_id,
      business_id: this.dataService.userDetails.business_id,
    });
  }

  createPurchaseOrder(data: any) {
    data = {
      ...data,
      user_id: this.dataService.userDetails.id,
      business_id: this.dataService.userDetails.business_id,
    };
    return this.http.post(this.apis.createPurchaseOrder, data);
  }
  createSalesOrder(data: any) {
    data = {
      ...data,
      user_id: this.dataService.userDetails.id,
      business_id: this.dataService.userDetails.business_id,
    };
    return this.http.post(this.apis.createSalesOrder, data);
  }

  getOrderData(
    order_type: string,
    search: any = '',
    bill_status: any = 0,
    vendor: any = 0,
    order_status: any = '',
    page: any = 1,
    limit: any = 10
  ) {
    const business_id = this.dataService.userDetails.business_id;
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.get(this.apis.getPurchaseOrderDataList, {
      params: {
        order_type,
        outlet_id,
        business_id,
        search,
        page,
        limit,
        bill_status,
        vendor,
        order_status,
      },
    });
  }

  getPurchaseOrderDetails(orderId: string | number) {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(
      this.apis.getPurchaseOrderDetails +
        '/' +
        orderId +
        '/' +
        business_id +
        '/' +
        this.dataService.selectedOutlet
      //   {
      //   params: { outlet_id },
      // }
    );
  }
  getSalesOrderDetails(orderId: string | number) {
    const outlet_id = this.dataService.selectedOutlet;
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(
      this.apis.getSalesOrderDetails +
        '/' +
        orderId +
        '/' +
        business_id +
        '/' +
        outlet_id
      //   {
      //   params: { outlet_id },
      // }
    );
  }

  getPurchaseOrderEditData(orderId: string | number) {
    return this.http.get(
      this.apis.getPurchaseOrderEditData + '/' + orderId
      //   {
      //   params: { outlet_id },
      // }
    );
  }

  getSalesOrderEditData(orderId: string | number) {
    return this.http.get(
      this.apis.getSalesOrderEditData + '/' + orderId
      //   {
      //   params: { outlet_id },
      // }
    );
  }

  getReceivingData(orderId: string | number) {
    return this.http.get(
      this.apis.getReceivingData + '/' + orderId
      //   {
      //   params: { outlet_id },
      // }
    );
  }
  getGRN(orderId: string | number) {
    return this.http.get(
      this.apis.getGRN + '/' + orderId
      //   {
      //   params: { outlet_id },
      // }
    );
  }

  approvePurchaseOrder(orderId: string | number) {
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.put(this.apis.approvePurchaseOrder + '/' + orderId, {
      outlet_id,
    });
  }

  approveSalesOrder(orderId: string | number) {
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.put(this.apis.approveSalesOrder + '/' + orderId, {
      outlet_id,
    });
  }

  updateReceivingData(
    id: string | number,
    received_quantity: number | string,
    received_price: number | string
  ) {
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.put(this.apis.updateReceivingData, {
      id,
      received_quantity,
      received_price,
    });
  }

  savePurchaseOrderEditData(data: any, id: string | number) {
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.put(this.apis.savePurchaseOrderEditData + '/' + id, {
      ...data,
    });
  }
  saveSalesOrderEditData(data: any, id: string | number) {
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.put(this.apis.saveSalesOrderEditData + '/' + id, {
      ...data,
    });
  }

  // ----------------------------------------------
  // ------------------ Inventory ---------------------

  getInventoryProducts(type: string | number) {
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.get(this.apis.getInventoryProducts, {
      params: {
        outlet_id,
        type,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  getInventoryLog(
    type: string | number,
    limit: number,
    page: number,
    search: string
  ) {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getInventoryLog, {
      params: {
        business_id,
        type,
        outlet_id: this.dataService.selectedOutlet,
        limit,
        page,
        search,
      },
    });
  }

  getInventoryList(type: string | number, id: string | number) {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getInventoryList + `/${id}`, {
      params: { business_id, type, outlet_id: this.dataService.selectedOutlet },
    });
  }

  createClosingInventory(inventory: any, formData: any) {
    const contact_id = this.dataService.userDetails.id;
    const outlet_id = formData.location;
    return this.http.post(this.apis.createClosingInventory, {
      inventory,
      contact_id,
      outlet_id,
      date: formData.date,
      time: formData.time,
    });
  }

  createWastageLog(inventory: any, formData: any) {
    const contact_id = this.dataService.userDetails.id;
    const outlet_id = formData.location;
    return this.http.post(this.apis.createWastageLog, {
      inventory,
      contact_id,
      outlet_id,
      date: formData.date,
      time: formData.time,
    });
  }

  getStockControl() {
    return this.http.get(this.apis.getStockControl, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  saveStockControl(data: any) {
    return this.http.post(this.apis.saveStockControl, {
      data,
      outlet_id: this.dataService.selectedOutlet,
      business_id: this.dataService.userDetails.business_id,
    });
  }

  getCurrentStock() {
    return this.http.get(this.apis.getCurrentStock, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }

  createStaffConsumptionLog(inventory: any, formData: any) {
    const contact_id = this.dataService.userDetails.id;
    const outlet_id = formData.location;
    return this.http.post(this.apis.createStaffConsumptionLog, {
      inventory,
      contact_id,
      outlet_id,
      date: formData.date,
      time: formData.time,
    });
  }

  // ---------------------------------------------------
  // ------------------ PERMISSIONS ---------------------

  getOutlets() {
    let business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getOutlets, { params: { business_id } });
  }

  getFeaturesList() {
    return this.http.get(this.apis.getFeaturesList);
  }

  getUserPermissions(contact_id: string | number) {
    return this.http.get(this.apis.getUserPermissions, {
      params: { contact_id },
    });
  }

  saveUserPermissions(contact_id: string | number, permissions: any) {
    return this.http.post(this.apis.saveUserPermissions, {
      contact_id,
      permissions,
    });
  }

  // ----------------------------------------------
  //--------------SMARTCART------------------------

  getItemsForSmartcart(
    search: string = '',
    page: number = 1,
    items: number = 10,
    categoryId: number = 0,
    templateId: number = 0
  ) {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getListOfItemsForSmartCart, {
      params: {
        business_id,
        outlet_id: this.dataService.selectedOutlet,
        search,
        page,
        items,
        categoryId,
        templateId,
      },
    });
  }

  getListOfItemsForCart() {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getListOfItemsForCart, {
      params: {
        business_id,
      },
    });
  }

  getCartItems() {
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.get(this.apis.getCartItems, { params: { outlet_id } });
  }

  addItemToCart(
    product_id: string | number,
    multiplier: number,
    moq: number,
    price: number,
    vendor_id: string | number
  ) {
    return this.http.post(this.apis.addItemToCart, {
      outlet_id: this.dataService.selectedOutlet,
      product_id,
      quantity: multiplier * moq,
      price: multiplier * price,
      vendor_id,
      user_id: this.dataService.userDetails.id,
    });
  }

  deleteCartItem(id: string | number) {
    return this.http.delete(this.apis.deleteCartItem, {
      params: { outlet_id: this.dataService.selectedOutlet, id },
    });
  }

  deleteCart() {
    return this.http.delete(this.apis.deleteCart, {
      params: { outlet_id: this.dataService.selectedOutlet },
    });
  }

  placeOrder() {
    return this.http.post(this.apis.placeOrder, {
      outlet_id: this.dataService.selectedOutlet,
      user_id: this.dataService.userDetails.id,
    });
  }

  getBillsForPO(order_id: string | number) {
    return this.http.get(this.apis.getBillsForPO, { params: { order_id } });
  }

  // ----------------------------------------------
  //-------------TEMPLATE--------------------------
  getTemplateList() {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getTemplateList, {
      params: { business_id, outlet_id: this.dataService.selectedOutlet },
    });
  }
  getTemplateItems(templateID: any) {
    return this.http.get(this.apis.getTemplateItems + '/' + templateID, {
      params: { outlet_id: this.dataService.selectedOutlet },
    });
  }
  getAllProducts() {
    const business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getAllProducts, {
      params: { business_id },
    });
  }
  deleteTemplate(id: any) {
    return this.http.delete(this.apis.deleteTemplate, {
      params: { id },
    });
  }

  createTemplate(templateName: string, items: any[]) {
    return this.http.post(this.apis.createTemplate, {
      template_name: templateName,
      business_id: this.dataService.userDetails.business_id,
      created_by: this.dataService.userDetails.id,
      items: items,
    });
  }
  editTemplate(templateId: any, template_name: string, items: any[]) {
    return this.http.put(this.apis.editTemplate, {
      id: templateId,
      template_name: template_name,
      items: items,
    });
  }
  //-------------BILLS--------------------------
  getAllBillList(
    status: string,
    outlet_id: string | number,
    start_date: string,
    end_date: string,
    department: string
  ) {
    const business_id = this.dataService.userDetails.business_id;
    outlet_id = outlet_id ? outlet_id : this.dataService.selectedOutlet;
    return this.http.get(this.apis.getAllBillList, {
      params: {
        business_id,
        status,
        outlet_id,
        start_date,
        end_date,
        department,
      },
    });
  }

  getBillList(
    status: string,
    outlet_id: string | number,
    start_date: string,
    end_date: string,
    department: string
  ) {
    const business_id = this.dataService.userDetails.business_id;

    return this.http.get(this.apis.getBillList, {
      params: {
        business_id,
        status,
        outlet_id,
        start_date,
        end_date,
        contact_id: this.dataService.userDetails.id,
        department,
      },
    });
  }

  updateBillStatus(billId: any, billStatus: any) {
    return this.http.put(this.apis.updateBillStatus, {
      id: billId,
      status: billStatus,
    });
  }

  billApproval(
    billId: any,
    billStatus: number,
    isAdmin: boolean = false,
    reason: string = ''
  ) {
    return this.http.post(this.apis.billApproval, {
      id: billId,
      status: billStatus,
      contact_id: this.dataService.userDetails.id,
      reason,
      isAdmin,
    });
  }

  uploadBillToS3(data: FormData, type: string) {
    // clear the existing business_id and type
    data.delete('business_id');
    data.delete('type');
    data.append('type', type);
    data.append('business_id', this.dataService.userDetails.business_id);
    return this.http.post(this.apis.uploadBillToS3, data);
  }

  getBillDocument(document: string) {
    return this.http.get(this.apis.getBillDocument, {
      params: {
        url: document,
      },
    });
  }

  createManualPayment(
    bill_id: number,
    ref_number: string,
    payment_date: string,
    payment_mode: string
  ) {
    return this.http.post(this.apis.createManualPayment, {
      business_id: this.dataService.userDetails.business_id,
      bill_id,
      ref_number,
      payment_date,
      payment_mode,
    });
  }

  deleteBillDocument(billId: any) {
    return this.http.delete(this.apis.deleteBillDocument, {
      params: {
        id: billId,
      },
    });
  }
  updateBill(
    bill_document: any,
    bill_date: any,
    vendor_id: any,
    amount: any,
    bill_number: any,
    order_id: any,
    id: any,
    type: any
  ) {
    let outlet_id = this.dataService.selectedOutlet;
    return this.http.put(this.apis.updateBill, {
      bill_document: bill_document,
      outlet_id: outlet_id,
      bill_date: bill_date,
      vendor_id: vendor_id,
      amount: amount,
      bill_number: bill_number,
      order_id: order_id,
      id: id,
      type: type,
    });
  }

  deleteBill(billId: any) {
    return this.http.delete(`${this.apis.deleteBill}`, {
      params: { id: billId },
    });
  }
  createBill(
    bill_document: any,
    bill_date: any,
    vendor_id: any,
    amount: any,
    bill_number: any,
    order_id: any,
    type: any
  ) {
    return this.http.post(this.apis.createBill, {
      bill_document,
      outlet_id: this.dataService.selectedOutlet,
      bill_date,
      vendor_id,
      amount,
      bill_number,
      order_id,
      type,
    });
  }

  getBillHistory(bill_id: number | string) {
    return this.http.get(this.apis.getBillHistory, {
      params: { bill_id },
    });
  }

  getVendorsForBills() {
    return this.http.get(this.apis.getVendorsForBills, {
      params: {
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }

  getPOForBills(vendor_id: string | number) {
    return this.http.get(this.apis.getPOForBills, {
      params: { vendor_id, outlet_id: this.dataService.selectedOutlet },
    });
  }

  createMultipleBills(bills: any) {
    bills.outlet_id = this.dataService.selectedOutlet;
    return this.http.post(this.apis.createMultipleBills, {
      bills,
    });
  }
  // ----------------------------------------------

  checkInvalidToken(err: any) {
    if (err.error.error == 'Invalid Login') {
      localStorage.removeItem('token');
    }
  }

  // -------------Production Planning---------------------------------
  getPlanningList(
    search: string = '',
    page: any = 1,
    limit: any = 10,
    status: any = -1
  ) {
    // outlet_id: this.dataService.selectedOutlet,
    //     business_id: this.dataService.userDetails.business_id,

    return this.http.get(this.apis.getPlanningList, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
        business_id: this.dataService.userDetails.business_id,
        search,
        page,
        limit,
        status,
      },
    });
  }

  viewPlanningData(planning_id: number | string) {
    return this.http.get(this.apis.viewPlanningData, {
      params: {
        business_id: this.dataService.userDetails.business_id,
        planning_id,
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }

  getRecipesForPlanning() {
    let outlet_id = this.dataService.selectedOutlet;
    let business_id = this.dataService.userDetails.business_id;
    return this.http.get(this.apis.getRecipesForPlanning, {
      params: { business_id, outlet_id },
    });
  }

  createPlanningList(date: any, recipes: any[], outlet_id: any) {
    return this.http.post(this.apis.createPlanningList, {
      outlet_id: outlet_id,
      date: date,
      recipes: recipes,
    });
  }

  getDataForUpdatingPopup(planningId: any) {
    return this.http.get(this.apis.getDataForUpdatingPopup, {
      params: {
        planning_id: planningId,
      },
    });
  }
  updateFinalQuantity(
    planId: any,
    finalQuantity: any,
    productId: any,
    location: any,
    plannedQuantity: any
  ) {
    return this.http.post(this.apis.updateFinalQuantity, {
      planning_id: planId,
      final_quantity: finalQuantity,
      product_id: productId,
      planned_quantity: plannedQuantity,
      location: location,
    });
  }

  getPlanningForInventoryLog(stockId: any) {
    return this.http.get(this.apis.getPlanningForInventoryLog, {
      params: {
        stock_id: stockId,
      },
    });
  }

  //------Categories--------
  getCategories() {
    return this.http.get(this.apis.getCategories, {
      params: {
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }

  createCategories(name: string, code: string) {
    return this.http.post(this.apis.createCategories, {
      name,
      code,
      business_id: this.dataService.userDetails.business_id,
    });
  }
  updateCategories(name: string, code: string, id: any) {
    return this.http.put(this.apis.updateCategories, {
      name,
      code,
      id,
    });
  }
  checkProductsOfCategories(id: any) {
    return this.http.get(this.apis.checkProductsOfCategories, {
      params: {
        id,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }
  changeCategoryOfProduct(product: any, category: any) {
    return this.http.put(this.apis.changeCategoryOfProduct, {
      product,
      category,
    });
  }
  deleteCategory(id: any) {
    return this.http.delete(this.apis.deleteCategory, {
      params: {
        id,
      },
    });
  }

  // ----------------------------------------------
  // ------------------ POS Orders ---------------------
  getPosOrders(
    outletId: string | number,
    startDate: string,
    endDate: string,
    platform: string | number,
    searchQuery: string,
    level: number
  ) {
    const params = new HttpParams()
      .set('businessId', this.dataService.userDetails.business_id)
      .set('outletId', outletId.toString())
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('platform', platform)
      .set('searchQuery', searchQuery)
      .set('level', level);
    return this.http.get(this.apis.getPosOrders, { params });
  }

  linkExternalIdWithProduct(
    product_id: string | number,
    external_item_id: string | number
  ) {
    return this.http.post(this.apis.linkExternalIdWithProduct, {
      product_id,
      external_item_id,
      business_id: this.dataService.userDetails.business_id,
    });
  }

  getPOSOrderRecipes() {
    const params = new HttpParams().set(
      'businessId',
      this.dataService.userDetails.business_id
    );
    return this.http.get(this.apis.getPOSOrderRecipes, { params });
  }

  getPosOrderItems(orderId: string | number) {
    return this.http.get(this.apis.getPosOrderInformation, {
      params: { inventoryLogId: orderId },
    });
  }

  // ----------------------------------------------
  // ------------------ Zoho ---------------------

  // getZohoAccessToken(code: string) {
  //   const body = {
  //     client_id: this.dataService.userDetails.zoho_client_id,
  //     grant_type: 'authorization_code',
  //     client_secret: this.dataService.userDetails.zoho_client_secret,
  //     redirect_uri: `${environment.frontendDomain}/purchase-order/bills`,
  //     code: code,
  //   };

  //   return this.http.post(this.apis.getZohoAccessToken, body);
  // }

  createZohoToken() {
    return this.http.get(this.apis.createToken, {
      params: {
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  getZohoContacts(type: string) {
    const params = new HttpParams()
      .set('business_id', this.dataService.userDetails.business_id)
      .set('type', type);
    // .set('access_token', access_token);

    return this.http.get(this.apis.getZohoContacts, { params });
  }

  getZohoAccounts() {
    const params = new HttpParams().set(
      'business_id',
      this.dataService.userDetails.business_id
    );
    // .set('access_token', access_token);

    return this.http.get(this.apis.getZohoAccounts, { params });
  }

  uploadBillToZoho(bill_ids: any[]) {
    return this.http.post(this.apis.uploadBillToZoho, {
      businessId: this.dataService.userDetails.business_id,
      bill_ids,
      outlet_id:
        this.dataService.selectedOutlet || this.dataService.outlets[0].id,
    });
  }

  // -----------------------------------------------
  // ------------------ Razorpay ---------------------

  createRazorpayPayout(bill_id: string | number) {
    return this.http.post(this.apis.createRazorpayPayout, {
      business_id: this.dataService.userDetails.business_id,
      bill_id,
    });
  }

  getRazorpayContacts() {
    return this.http.get(this.apis.getRazorpayContacts, {
      params: {
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  getRazorpayFunds() {
    return this.http.get(this.apis.getRazorpayFunds, {
      params: {
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  getRazorpayHistory(bill_id: number) {
    return this.http.get(this.apis.getRazorpayHistory, {
      params: {
        bill_id,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  // ----------------------------------------------
  // ------------------ Settings ---------------------

  getBillSettings() {
    return this.http.get(this.apis.getBillSettings, {
      params: {
        businessId: this.dataService.userDetails.business_id,
      },
    });
  }

  createBillSettings(permissions: any) {
    return this.http.post(this.apis.createBillSettings, {
      businessId: this.dataService.userDetails.business_id,
      permissions,
    });
  }

  checkBillPermissions() {
    return this.http.get(this.apis.checkBillPermissions, {
      params: {
        businessId: this.dataService.userDetails.business_id,
      },
    });
  }

  getContactsForBillSettings() {
    return this.http.get(this.apis.getContactsForBillSettings, {
      params: {
        businessId: this.dataService.userDetails.business_id,
      },
    });
  }

  getBillGroups() {
    return this.http.get(this.apis.getBillGroups, {
      params: {
        businessId: this.dataService.userDetails.business_id,
      },
    });
  }

  createBillGroups(name: string, contacts: any[]) {
    return this.http.post(this.apis.createBillGroups, {
      businessId: this.dataService.userDetails.business_id,
      name,
      contacts,
    });
  }

  updateBillGroup(name: string, contacts: any[], id: number) {
    return this.http.put(this.apis.updateBillGroup, {
      businessId: this.dataService.userDetails.business_id,
      name,
      contacts,
      id,
    });
  }

  deleteBillGroup(id: number) {
    return this.http.delete(this.apis.updateBillGroup, {
      params: { id },
    });
  }

  // ----------------------------------------------
  // ------------------ Notifications ---------------------
  getNotifications(notificationId: number, start = 0) {
    return this.http.get(this.apis.getNotifications, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
        business_id: this.dataService.userDetails.business_id,
        notificationId,
        start,
      },
    });
  }

  changeReadStatus(notification_id: number | string, status: number) {
    return this.http.put(this.apis.changeReadStatus, {
      notification_id,
      status,
    });
  }

  markAsDelete(notification_id: number | string) {
    return this.http.delete(this.apis.markAsDelete, {
      params: { notification_id },
    });
  }

  // ----------------------------------------------
  // ------------------ Dashboard ---------------------

  getDashboardWidgets() {
    return this.http.get(this.apis.getDashboardWidgets);
  }

  createWidgetsLayout(group_id: number, widgets: any[]) {
    return this.http.post(this.apis.createWidgetsLayout, {
      group_id,
      business_id: this.dataService.userDetails.business_id,
      widgets,
    });
  }

  getWidgetsForGroup(group_id: number) {
    return this.http.get(this.apis.getWidgetsForGroup, {
      params: {
        group_id,
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }

  getListOfWidgetsForUser() {
    return this.http.get(this.apis.getListOfWidgetsForUser, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
        business_id: this.dataService.userDetails.business_id,
        contact_id: this.dataService.userDetails.id,
      },
    });
  }

  getSalesOrdersForDashboard(from: string, to: string) {
    return this.http.get(this.apis.getSalesOrdersForDashboard, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
        business_id: this.dataService.userDetails.business_id,
        from,
        to,
      },
    });
  }

  getPurchaseOrdersForDashboard(from: string, to: string) {
    return this.http.get(this.apis.getPurchaseOrdersForDashboard, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
        business_id: this.dataService.userDetails.business_id,
        from,
        to,
      },
    });
  }

  getPurchaseSalesForDashboard(from: string, to: string) {
    return this.http.get(this.apis.getPurchaseSalesForDashboard, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
        business_id: this.dataService.userDetails.business_id,
        from,
        to,
      },
    });
  }
  getOrderCount(from: string, to: string) {
    return this.http.get(this.apis.getOrderCount, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTotalSalesValue(from: string, to: string) {
    return this.http.get(this.apis.getTotalSalesValue, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTotalSalesCount(from: string, to: string) {
    return this.http.get(this.apis.getTotalSalesCount, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTotalDiscount(from: string, to: string) {
    return this.http.get(this.apis.getTotalDiscount, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTotalProductsSold(from: string, to: string) {
    return this.http.get(this.apis.getTotalProductsSold, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getAverageOrderValue(from: string, to: string) {
    return this.http.get(this.apis.getAverageOrderValue, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getAverageProductPerOrder(from: string, to: string) {
    return this.http.get(this.apis.getAverageProductPerOrder, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getSalesByPlatform(from: string, to: string) {
    return this.http.get(this.apis.getSalesByPlatform, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTopSellingItemByRevenue(from: string, to: string) {
    return this.http.get(this.apis.getTopSellingItemByRevenue, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // business_id: 2,
        // outlet_id: 0,
      },
    });
  }
  getTotalPurchaseCount(from: string, to: string) {
    return this.http.get(this.apis.getTotalPurchaseCount, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTotalPurchaseValue(from: string, to: string) {
    return this.http.get(this.apis.getTotalPurchaseValue, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getToatlPurchaseValues(from: string, to: string) {
    return this.http.get(this.apis.getToatlPurchaseValues, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getRecentPurchaseHistory(from: string, to: string) {
    return this.http.get(this.apis.getRecentPurchaseHistory, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        // // outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTopWastageItems(from: string, to: string) {
    return this.http.get(this.apis.getTopWastageItems, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getTotalWastageValue(from: string, to: string) {
    return this.http.get(this.apis.getTotalWastageValue, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }
  getProductsBySale(from: string, to: string) {
    return this.http.get(this.apis.getProductsBySale, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }

  getTotalVarianceValue(from: string, to: string) {
    return this.http.get(this.apis.getTotalVarianceValue, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }

  getTotalInventoryValue(from: string, to: string) {
    return this.http.get(this.apis.getTotalInventoryValue, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }

  getTopVarianceItems(from: string, to: string) {
    return this.http.get(this.apis.getTopVarianceItems, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
        // outlet_id: 0,
        // business_id: 2,
      },
    });
  }

  getIncomeExpense(from: string, to: string) {
    return this.http.get(this.apis.getIncomeExpense, {
      params: {
        from,
        to,
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }

  // ----------------------------------------------
  // ------------------ Shopify -------------------
  fetchShopifyProducts() {
    return this.http.get(this.apis.fetchShopifyProducts, {
      params: {
        business_id: this.dataService.userDetails.business_id,
        outlet_id:
          this.dataService.selectedOutlet || this.dataService.outlets[0].id,
      },
    });
  }

  saveShopifyProducts(products: any[]) {
    return this.http.post(this.apis.saveShopifyProducts, {
      products,
    });
  }
  // ----------------------------------------------
  // ------------------ Woocommerce -------------------
  fetchWoocommerceProducts() {
    return this.http.get(this.apis.fetchWoocommerceProducts, {
      params: {
        business_id: this.dataService.userDetails.business_id,
        outlet_id:
          this.dataService.selectedOutlet || this.dataService.outlets[0].id,
      },
    });
  }

  saveWoocommerceProducts(products: any[]) {
    return this.http.post(this.apis.saveWoocommerceProducts, {
      products,
    });
  }

  // sequence settings
  getSequenceData() {
    return this.http.get(this.apis.getSequenceData, {
      params: {
        business_id: this.dataService.userDetails.business_id,
      },
    });
  }
  addSequenceData(data: any) {
    return this.http.post(this.apis.addSequenceData, {
      sequence: data,
      business_id: this.dataService.userDetails.business_id,
    });
  }

  getIntegrationsForProducts() {
    return this.http.get(this.apis.getIntegrationsForProducts, {
      params: {
        business_id: this.dataService.userDetails.business_id,
        outlet_id: this.dataService.selectedOutlet || 0,
      },
    });
  }

  addIntegrations(data: any) {
    return this.http.post(this.apis.addIntegrations, data);
  }

  deleteIntegration(id: any) {
    return this.http.delete(`${this.apis.deleteIntegration}/${id}`);
  }

  updateIntegration(id: any, data: any) {
    return this.http.put(`${this.apis.updateIntegration}/${id}`, data);
  }

  requestOtp(email: string) {
    return this.http.post(this.apis.requestOtp, { email });
  }

  verifyOtp(email: string, otp: string) {
    return this.http.post(this.apis.verifyOtp, {
      email,
      otp,
    });
  }
  twoFactorAuth(contact_id: number, token: number) {
    return this.http.post(this.apis.twoFactorAuth, {
      contact_id,
      token,
    });
  }

  // ----------------------------------------------

  // ------------------ Schedules -------------------
  getSchedules() {
    return this.http.get(this.apis.getSchedules, {
      params: {
        business_id: this.dataService.userDetails.business_id,
        contact_id: this.dataService.userDetails.id,
      },
    });
  }

  createSchedule(schedule: any) {
    return this.http.post(this.apis.createSchedule, {
      schedule,
      business_id: this.dataService.userDetails.business_id,
      contact_id: this.dataService.userDetails.id,
    });
  }
  // ----------------------------------------------
  // ------------------ Auth ----------------------
  generate2FA() {
    const contact_id = this.dataService.userDetails.id;
    return this.http.get(this.apis.generate2FA, {
      params: {
        contact_id,
      },
    });
  }

  delete2FA() {
    const contact_id = this.dataService.userDetails.id;
    return this.http.delete(this.apis.delete2FA, {
      params: {
        contact_id,
      },
    });
  }

  save2FA(secret: string) {
    const contact_id = this.dataService.userDetails.id;
    return this.http.post(this.apis.save2FA, {
      secret,
      contact_id,
    });
  }

  get2FAInformation() {
    const contact_id = this.dataService.userDetails.id;
    return this.http.get(this.apis.get2FAInformation, {
      params: {
        contact_id,
      },
    });
  }

  /// invoices
  getInvoices() {
    const business_id = this.dataService.userDetails.business_id;
    const outlet_id = this.dataService.selectedOutlet;
    return this.http.get(this.apis.getInvoices, {
      params: { business_id, outlet_id },
    });
  }

  addInvoices(data: any) {
    return this.http.post(this.apis.addInvoices, data);
  }
  viewInvoices(id: any) {
    return this.http.get(`${this.apis.viewInvoices}/${id}`);
  }

  // -----------------------------------------------
  // ------------------ Language ---------------------

  getLanguage() {
    return this.http.get(this.apis.getLanguage, {
      params: {
        id: this.dataService.userDetails.id,
      },
    });
  }

  changeLanguage(language: any) {
    return this.http.put(this.apis.changeLanguage, {
      contact_id: this.dataService.userDetails.id,
      language,
    });
  }
  getAllProductsForProductsNav() {
    return this.http.get(this.apis.getAllProductsForProductsNav);
  }

  // bulk sales

  syncInventory(data: any[], sellingPrice: any) {
    const outletId = this.dataService.selectedOutlet;

    const DATA = [outletId, data, sellingPrice];
    return this.http.post(this.apis.syncInventory, {
      outlet_id: outletId,
      data,
      sellingPrice,
    });
  }

  getAllProductsForBulkSales() {
    return this.http.get(this.apis.getAllProductsForBulkSales, {
      params: {
        outlet_id: this.dataService.selectedOutlet,
      },
    });
  }
}

// -----------------------------------------------
